<template>
  <div class="app-layout">
      <app-header></app-header>
      <div class="app-header-fake"></div>
      <main class="main">
        <div class="app-body">
          <transition name="fade" mode="out-in">
            <router-view ></router-view>
          </transition>
        </div>
      </main>
      <!-- <a href="https://www.messenger.com/t/reborn.academy" target="_blank">
        <div class="app-messenger">
          <svg-icon
            icon-class="messenger"
            class="messenger-icon"
          ></svg-icon>
        </div>
      </a> -->
      <!-- Load Facebook SDK for JavaScript -->
      <div id="fb-root"></div>
      <app-footer></app-footer>
  </div>
</template>
<script>
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'

export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>
<style lang="scss" scoped>
.app-layout {
  width: 100%;

  .app-header-fake {
    width: 100%;
    height: 114px;
  }

  .main {
    min-height: 100vh;
    // max-width: 1200px;
    width: 100%;
    margin: auto;
  }

  .app-body {
    // padding: 0px 64px;
  }

  .app-messenger {
    position: fixed;
    right: 0px;
    bottom: 50px;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: solid 1.5px #000000;
    border-top: solid 1.5px #000000;
    border-bottom: solid 1.5px #000000;
    border-radius: 39px 0px 0px 39px;
    background: #fff;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    .messenger-icon {
      width: 51px;
      height: 45px;
    }
  }
}

@media( max-width: 500px ){

.app-layout {

    .app-header-fake {
    width: 100%;
    height: 52px;
  }

  .main {
    min-height: 100vh;
    max-width: auto;
    // padding: 0px 15px;
  }

  .app-body {
    padding: 0px;
  }

  .app-messenger {

    .messenger-icon {

    }
  }
}

}
</style>



// WEBPACK FOOTER //
// src/components/layout/AppLayout.vue